(function(){
  var R=document.documentElement;
  function onScroll(){ if(window.scrollY>40){R.classList.add('cx-scrolled');}else{R.classList.remove('cx-scrolled');} }
  onScroll(); window.addEventListener('scroll',onScroll,{passive:true});
  var reduce=false; try{ reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){}
  // Image fade-in (product/collection media only)
  if(!reduce){
    var imgs=document.querySelectorAll('.card__media img, .product__media img, .media img');
    imgs.forEach(function(im){
      im.classList.add('cx-img');
      if(im.complete && im.naturalWidth>0){ im.classList.add('cx-imgin'); }
      else { im.addEventListener('load',function(){im.classList.add('cx-imgin');}); im.addEventListener('error',function(){im.classList.add('cx-imgin');}); }
    });
    setTimeout(function(){ document.querySelectorAll('.cx-img:not(.cx-imgin)').forEach(function(im){im.classList.add('cx-imgin');}); },2000);
  }
  // Scroll reveal for below-the-fold sections (no hero flash)
  if(reduce || !('IntersectionObserver' in window)) return;
  var vh=window.innerHeight||800, fold=vh*0.85;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('cx-in'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px 12% 0px',threshold:0.01});
  document.querySelectorAll('.shopify-section').forEach(function(s){
    if(s.getBoundingClientRect().top>fold){ s.classList.add('cx-reveal'); io.observe(s); }
  });
})();


/* PDP face-shape guide under the fit line */
(function(){
  function go(){
    var fit=document.querySelector('.cxfit'); if(!fit||document.getElementById('cxfg'))return;
    var txt=fit.textContent||'';
    var SH={Oval:['<path d="M20 3 C28 3 32 13 32 25 C32 39 27 47 20 47 C13 47 8 39 8 25 C8 13 12 3 20 3 Z"/>','Longer than wide, soft edges.'],
            Round:['<path d="M20 4 C30 4 35 13 35 25 C35 38 29 46 20 46 C11 46 5 38 5 25 C5 13 10 4 20 4 Z"/>','As wide as it is long, full cheeks.'],
            Square:['<path d="M11 5 L29 5 C32 5 34 8 34 12 L34 33 C34 40 30 45 20 46 C10 45 6 40 6 33 L6 12 C6 8 8 5 11 5 Z"/>','Strong, even jaw.'],
            Heart:['<path d="M20 46 C12 37 6 26 6 16 C6 10 9 6 13 6 C16 6 18 9 20 12 C22 9 24 6 27 6 C31 6 34 10 34 16 C34 26 28 37 20 46 Z"/>','Wide forehead, narrower chin.']};
    var present=Object.keys(SH).filter(function(k){return new RegExp(k,'i').test(txt);});
    if(!present.length) return;
    var cards=present.map(function(k){var s=SH[k];return '<div style="display:flex;align-items:center;gap:.65rem;background:#fff;border:1px solid #e7e9ec;border-radius:12px;padding:.6rem .7rem;"><span style="flex:0 0 auto;width:44px;height:44px;border-radius:50%;background:#eef0f3;display:flex;align-items:center;justify-content:center;"><svg viewBox="0 0 40 50" fill="none" stroke="#16181d" stroke-width="2.4" stroke-linejoin="round" style="width:25px;height:29px;">'+s[0]+'</svg></span><span><span style="display:block;font-weight:700;font-size:13px;">'+k+'</span><span style="display:block;font-size:11.5px;color:#6b7280;line-height:1.3;margin-top:.08rem;">'+s[1]+'</span></span></div>';}).join('');
    var wrap=document.createElement('div'); wrap.id='cxfg'; wrap.style.marginTop='.6rem';
    wrap.innerHTML='<a href="/pages/find-your-fit" style="font-size:13px;color:#777;text-decoration:underline;text-underline-offset:3px;">Not sure of your face shape? Measure it →</a>';
    fit.insertAdjacentElement('afterend', wrap);
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();


/* Self-healing story images: pull each product's live featured image by handle so a stale catalog filename can never break a blog post again */
(function(){
  function heal(){
    [].forEach.call(document.querySelectorAll('img[data-cx-product]'),function(img){
      var h=img.getAttribute('data-cx-product'); if(!h) return;
      fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
        if(p&&p.featured_image){var u=(''+p.featured_image).replace(/^\/\//,'https://'); if(img.getAttribute('src')!==u) img.src=u;}
      }).catch(function(){});
    });
  }
  if(document.readyState!=='loading')heal(); else document.addEventListener('DOMContentLoaded',heal);
})();


/* See Through the Lens link on Prizm product pages */
(function(){
  function go(){
    if(document.getElementById('cxlp-pdp')) return;
    var h1=document.querySelector('h1.product__title, .product__title');
    if(!h1||!/prizm/i.test(h1.textContent)) return;
    var price=document.querySelector('.product__info-container .price__container,.product__info-container .price');
    var anchor=price||h1;
    var wrap=document.createElement('p');
    wrap.id='cxlp-pdp';
    wrap.style.cssText='margin:6px 0 2px;font-size:13px;';
    wrap.innerHTML='<a href="/pages/see-your-lens" style="color:#888;text-decoration:underline;text-underline-offset:3px;">See what this lens looks like &#8594;</a>';
    anchor.insertAdjacentElement('afterend',wrap);
  }
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
})();
